import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Subject } from 'rxjs';
import { RegularDateFormatMMMdy } from '@anecdotes/helpers';
import { TrustCenterFacadeService, UserResponse, UserStatus } from '@anecdotes/shared-trust-center';
import { TrustCenterModalService } from '../../../../services/trustcenter-modals/trustcenter-modals.service';

@Component({
  selector: 'app-requests-item',
  templateUrl: './requests-item.component.html',
  styleUrls: ['./requests-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestsItemComponent {
  readonly dateFormat = RegularDateFormatMMMdy;
  readonly denying$ = new Subject<boolean>();

  @Input()
  request: UserResponse;

  get wasRevoked(): boolean {
    return this.request.previous_status === UserStatus.Revoked;
  }

  constructor(
    private trustCenterFacadeService: TrustCenterFacadeService,
    private trustCenterModalService: TrustCenterModalService,
  ) {}

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  async denyAccess(): Promise<void> {
    try {
      this.denying$.next(true);
      if (this.wasRevoked) {
        await this.trustCenterFacadeService.revokeUser(this.request.email);
      } else {
        await this.trustCenterFacadeService.denyUser(this.request.email);
      }
    } finally {
      this.denying$.next(false);
    }
  }

  openViewRequestSidePanel(): void {
    this.trustCenterModalService.openAccessRequestSidePanel(this.request);
  }
}
